import React from 'react';
import PropTypes from 'prop-types';
import { Formik as FormikControllerComponent } from 'formik';
import withLocalization from '../../higherOrderComponents/withLocalization';
import FormikFormElementController from './_FormikFormElementController';


const FormikForm = ({
  getFormikProps,
  initialValues = {},
  handleDirtyForm,
  validateOnBlur,
  validateOnChange,
  onSubmit,
  validationSchema,
  formClassNames,
  ignoreAbandoningDirtyForm,
  translate,
  render,
  children
}) => {
  const controllerAttributes = {
    validateOnBlur,
    validateOnChange,
    onSubmit,
    initialValues,
    validationSchema,
    render
  };

  if (Array.isArray(initialValues)) {
    throw new Error('initialValues formatted as array - it should be an object!');
  }

  const formAttributes = { noValidate: true };

  if (formClassNames && formClassNames.length > 0) {
    formAttributes.className = formClassNames.join(' ');
  }

  return (
    <FormikControllerComponent {...controllerAttributes}>
      {formikProps => {
        const {
          // values,
          dirty,
          errors,
          isSubmitting
        } = formikProps;

        const FormikFormContext = React.createContext();

        if (getFormikProps) {
          getFormikProps(formikProps);
        }

        return (
          <React.Fragment>
            <FormikFormElementController
              formElementAttributes={formAttributes}
              formSubmission={{ isSubmitting, errors }}
              isFormDirty={dirty}
              handleDirtyForm={handleDirtyForm}
            >
              {(typeof (children) !== 'function') ? children : (
                <FormikFormContext.Provider value={formikProps}>
                  <FormikFormContext.Consumer>
                    {children}
                  </FormikFormContext.Consumer>
                </FormikFormContext.Provider>
              )}
            </FormikFormElementController>
          </React.Fragment>
        );
      }}
    </FormikControllerComponent>
  );
};

FormikForm.propTypes = {
  initialValues: PropTypes.object,
  getFormikProps: PropTypes.func,
  handleDirtyForm: PropTypes.func,
  validateOnBlur: PropTypes.bool,
  validateOnChange: PropTypes.bool,
  onSubmit: PropTypes.func,
  validationSchema: PropTypes.object,
  formClassNames: PropTypes.arrayOf(PropTypes.string),
  ignoreAbandoningDirtyForm: PropTypes.bool,
  render: PropTypes.func
};

export default withLocalization(FormikForm, 'general/messages');
